import { ArrowLeft } from 'lucide-react';
import { SOMMETS } from './decorRegions';

/**
 * « Le Volcan des Nombres » — scène d'attente, jumelle de ForetBrume :
 * montée quand la région n'a AUCUN thème jouable (l'autonomie ne sert que
 * les automatismes à générateur). Pilotée par les données, pas par le
 * niveau : tous les niveaux ont leurs automatismes depuis septembre 2026,
 * cette scène ne se voit plus que si le référentiel du niveau n'expose pas
 * la rubrique ou si le front déployé date d'avant les générateurs.
 */
function VolcanBrume({ region, onBack }) {
    const sommet = SOMMETS.volcan;
    return (
        <div
            className="eleve-gamified fixed inset-0 z-[100] overflow-hidden flex flex-col"
            style={{ background: 'radial-gradient(120% 90% at 50% 110%, #2a160e 0%, #1a1526 45%, #0A1F3D 100%)' }}
        >
            <div className="absolute inset-x-0 top-0 h-72 pointer-events-none" style={{ background: sommet.fond }} />

            <div className="relative flex items-center p-5">
                <button onClick={onBack} aria-label="Retour à l'île" className="p-2.5 rounded-xl text-white" style={{ background: 'rgba(255,255,255,.1)' }}>
                    <ArrowLeft className="w-5 h-5" />
                </button>
            </div>

            <div className="relative flex-1 flex flex-col items-center justify-center px-6 text-center -mt-10">
                <div className="relative w-full max-w-md">
                    <svg viewBox={sommet.viewBox} className="w-full h-auto block" aria-hidden="true">
                        {sommet.elements.map((el, i) => (
                            <path key={i} d={el.d} fill={el.fill} opacity={el.opacity} />
                        ))}
                    </svg>
                    {/* Brume dérivante sur les crêtes */}
                    <svg className="absolute inset-x-0 bottom-0 w-full pointer-events-none" viewBox="0 0 320 70" aria-hidden="true">
                        <ellipse className="ile-mist" cx="100" cy="38" rx="95" ry="20" fill="rgba(255,255,255,.20)" style={{ filter: 'blur(7px)' }} />
                        <ellipse className="ile-mist" cx="230" cy="48" rx="85" ry="17" fill="rgba(255,255,255,.14)" style={{ filter: 'blur(7px)', animationDelay: '1.8s' }} />
                    </svg>
                </div>
                <h1 className="text-white text-2xl mt-4">{region.emoji} {region.nom}</h1>
                <p className="mt-2 text-sm font-bold max-w-xs" style={{ color: 'rgba(255,255,255,.65)' }}>
                    Le volcan gronde sous la surface… Les défis de ton niveau
                    arrivent. Reviens bientôt ! 🌋
                </p>
            </div>
        </div>
    );
}

export default VolcanBrume;
